import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import { PendingMissionStaffingApplicationFragmentFragment } from "@/gql"
import PositionDetails from "@/modules/Missions/components/Details/ManageTeamRoles/StaffingPositionDetails/PositionDetails.vue"
import { ApplicationStates, ApplicationActions } from "./constant"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationTabContent',
  props: {
    applications: null
  },
  emits: ["click:applicant", "update-selected-application-details"],
  setup(__props: any, { emit }) {





const disabledApproveApplicant = (
  application: PendingMissionStaffingApplicationFragmentFragment
) => {
  return (
    application.state === ApplicationStates.rejected ||
    application.state === ApplicationStates.approved
  )
}

const disableShortlistApplicant = (
  application: PendingMissionStaffingApplicationFragmentFragment
) => {
  return application.state === ApplicationStates.pending
}

const disableDeclineApplicant = (
  application: PendingMissionStaffingApplicationFragmentFragment
) => {
  return (
    application.state === ApplicationStates.approved ||
    application.state === ApplicationStates.rejected
  )
}

const onConfirmShortlistApplicant = (
  application: PendingMissionStaffingApplicationFragmentFragment
) => {
  emit("update-selected-application-details", {
    message: "You are about to shortlist this applicant",
    btnText: "Yes shortlist",
    application,
    action: ApplicationActions.shortlist,
  })
}

const onConfirmDeclineApplicant = (
  application: PendingMissionStaffingApplicationFragmentFragment
) => {
  emit("update-selected-application-details", {
    message: "You are about decline this application for this role",
    btnText: "Yes decline",
    application,
    action: ApplicationActions.decline,
  })
}

const onConfirmApproveApplicant = (
  application: PendingMissionStaffingApplicationFragmentFragment
) => {
  emit("update-selected-application-details", {
    message:
      "You are about to approve this application for this role. A contract will be automatically created and sent to the consultant for acceptance.",
    btnText: "Yes approve",
    application,
    action: ApplicationActions.approve,
  })
}

return { __sfc: true,emit, disabledApproveApplicant, disableShortlistApplicant, disableDeclineApplicant, onConfirmShortlistApplicant, onConfirmDeclineApplicant, onConfirmApproveApplicant, Icon, PositionDetails }
}

})